import React, { Component } from "react";

import Sqgradbtn from "../molecules/Sqgradbtn";

function statusHelper(response) {
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response);
  } else {
    return Promise.reject({
      error: new Error(response.statusText),
      status: response.status
    });
  }
}

export default class Contactus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      sender: "",
      message: "",
      phase: "normal"
    };
  }
  submit(e) {
    e.preventDefault();
    this.setState({ phase: "loading" });
    fetch("https://contact.limenius.com/contact", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      mode: "cors",
      //credentials: 'same-origin',
      body: JSON.stringify({
        name: this.state.name,
        sender: this.state.sender,
        message: this.state.message
      })
    })
      .then(statusHelper)
      .then(response => {
        this.setState({ phase: "done" }, () =>
          setTimeout(() => {
            this.setState({
              phase: "normal",
              name: "",
              message: "",
              sender: ""
            });
          }, 5000)
        );
        console.log("done");
        return response;
      })
      .catch(error => {
        console.log(error);
        this.setState({ phase: "error" }, () =>
          setTimeout(() => {
            this.setState({ phase: "normal" });
          }, 5000)
        );
      });
  }
  render() {
    return (
      <div className="contactus">
        <div className="container">
          <div className="contactus--wrap">
            <div className="contactus--heading">Tell us about your project</div>
            <form onSubmit={this.submit.bind(this)}>
              <input
                type="text"
                id="form_name"
                name="form[name]"
                required="required"
                placeholder="Your Name"
                value={this.state.name}
                onChange={e => this.setState({ name: e.target.value })}
              />
              <input
                type="email"
                id="form_email"
                name="form[email]"
                required="required"
                placeholder="Your Email"
                value={this.state.sender}
                onChange={e => this.setState({ sender: e.target.value })}
              />
              <textarea
                id="message"
                name="form[message]"
                placeholder="Message"
                value={this.state.message}
                onChange={e => this.setState({ message: e.target.value })}
              />
              {this.state.phase === "done" && (
                <div className="c-contactus--status c-contactus--success">
                  Your message has been sent. Thanks! We will get back to you
                  soon!
                </div>
              )}
              {this.state.phase === "error" && (
                <div className="c-contactus--status c-contactus--error">
                  Oops! something is not right. If this problem persists, just
                  write us at <strong>contact@limenius.com</strong>
                </div>
              )}
              <Sqgradbtn
                type="submit"
                onClick={e => e.preventDefault()}
                phase={this.state.phase}
              >
                SEND
              </Sqgradbtn>
            </form>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/organisms/Contactus.js